module.exports = __webpack_public_path__ + "img/login.bbfcbfea.jpg";